// src/services/CandidateService.js
import { apiClient } from "../../base/ApiClient";

export const createCandidate = async (formData) => {
  const response = await apiClient.post(`/candidate/create/`, formData);
  return response;
};

export const getCandidates = async (page, search, location_id) => {
  const response = await apiClient.get(
    `candidate/lists/?page=${page}&search=${search}&location=${location_id}`
  );
  return response.data;
};

export const searchCandidates = async (search = "", locationId = null) => {
  let url = `/candidate/search/?search=${search}`;
  
  if (locationId) {
    url += `&location=${locationId}`;
  }

  const response = await apiClient.get(url);
  return response.data;
};

export const getCandidatesbyId = async (candidate_id) => {
  const response = await apiClient.get(`candidate/${candidate_id}/`);
  return response.data;
};

export const updateCandidate = async (formData, candidate_id) => {
  const response = await apiClient.patch(
    `/candidate/${candidate_id}/update/`,
    formData
  );
  return response;
};

export const getNote = async (page, candidate_id) => {
  const response = await apiClient.get(
    `/communications/users/notes?page=${page}&candidate=${candidate_id}`
  );
  return response.data;
};

export const createNote = async (formData) => {
  const response = await apiClient.post(
    `/communications/notes/create`,
    formData
  );
  return response.data;
};

export const createCandidateNote = async (formData) => {
  const response = await apiClient.post(
    `/communications/candidate-notes/`,
    formData
  );
  return response;
};

export const getCandidateNote = async (candidate_id) => {
  const response = await apiClient.get(
    `/communications/candidate-notes/?candidate=${candidate_id}`
  );
  return response.data;
};

export const getCandidateSkills = async (candidate_id) => {
  const response = await apiClient.get(
    `/candidate/candidate-skills/?candidate=${candidate_id}`
  );
  return response.data;
};

export const createCandidateSkill = async (data) => {
  const response = await apiClient.post(
    `/candidate/candidate-skills/`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const updateCandidateSkill = async (id, data) => {
  const response = await apiClient.patch(
    `/candidate/candidate-skills/${id}/`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const deleteCandidateSkill = async (id) => {
  const response = await apiClient.delete(`/candidate/candidate-skills/${id}/`);
  return response;
};

export const addSkillDocument = async (id, documentUrl) => {
  const response = await apiClient.post(
    `/candidate/candidate-skills/${id}/add_document/`,
    {
      document_url: documentUrl,
    }
  );
  return response.data;
};

export const removeSkillDocument = async (id, documentUrl) => {
  const response = await apiClient.post(
    `/candidate/candidate-skills/${id}/remove_document/`,
    {
      document_url: documentUrl,
    }
  );
  return response.data;
};

export const addMultipleSkillDocuments = async (id, documentUrls) => {
  const response = await apiClient.post(
    `/candidate/candidate-skills/${id}/add_multiple_documents/`,
    {
      document_urls: documentUrls,
    }
  );
  return response.data;
};

export const getCandidateEmployment = async (candidate_id) => {
  const response = await apiClient.get(
    `/candidate/employment/?candidate=${candidate_id}`
  );
  return response.data;
};

export const createCandidateEmployment = async (formdata) => {
  const response = await apiClient.post(`/candidate/employment/`, formdata);
  return response;
};

export const updateCandidateEmployment = async (id, formData) => {
  const response = await apiClient.patch(
    `/candidate/employment/${id}/`,
    formData
  );
  return response;
};

export const createCandidateWorkingPattern = async (formdata) => {
  const response = await apiClient.post(
    `/candidate/working-patterns/`,
    formdata
  );
  return response;
};

export const createOrUpdateWorkingPattern = async (formdata) => {
  const response = await apiClient.post(
    `/candidate/working-patterns/create_or_update_by_candidate/`,
    formdata
  );
  return response;
};

export const getCandidateWorkingPattern = async (candidate_id) => {
  const response = await apiClient.get(
    `/candidate/working-patterns/candidate_pattern/?candidate_id=${candidate_id}`
  );
  return response.data;
};

export const getCandidateHolidays = async (candidateId) => {
  const response = await apiClient.get(`/candidate/holidays/?candidate=${candidateId}`);
  return response.data;
};

export const createCandidateHoliday = async (data) => {
  const response = await apiClient.post(`/candidate/holidays/`, data);
  return response;
};

export const updateCandidateHoliday = async (id, data) => {
  const response = await apiClient.patch(`/candidate/holidays/${id}/`, data);
  return response;
};

export const deleteCandidateHoliday = async (id) => {
  const response = await apiClient.delete(`/candidate/holidays/${id}/`);
  return response;
};

export const createCandidateCredentials = async (data) => {
  const response = await apiClient.post(`/candidate/create-user-credentials/`, data);
  return response.data;
};

export const getCandidateCredentials = async (candidateId) => {
  const response = await apiClient.get(`/candidate/credentials/?candidate=${candidateId}`);
  return response.data;
};

export const updateCandidateCredentials = async (id, data) => {
  const response = await apiClient.patch(`/candidate/credentials/${id}/`, data);
  return response.data;
};

export const deleteCandidateCredential = async (id) => {
  const response = await apiClient.delete(`/candidate/credentials/${id}/`);
  return response;
};

export const getUnAllocatedCandidates = async (page, location) => {
  const params = new URLSearchParams();
  params.append("page", page);
  if (location) {
    params.append("location", location);
  }

  const response = await apiClient.get(
    `/candidate/unallocated/?${params.toString()}`
  );
  return response.data;
};

export const setPassword = async (token, password, confirmPassword) => {
  try {
    const response = await apiClient.post(`/candidate/set-password/`, {
      token,
      password,
      confirm_password: confirmPassword
    });
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.token || 
                        error.response?.data?.password || 
                        error.response?.data?.message ||
                        "Failed to set password";
    return { success: false, error: errorMessage };
  }
};

export const resendSetupLink = async (email) => {
  try {
    const response = await apiClient.post(`/candidate/resend-link/`, {
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.email || 
                        error.response?.data?.message ||
                        "Failed to resend link";
    return { success: false, error: errorMessage };
  }
};

export const resendPasswordReset = async (email) => {
  try {
    const response = await apiClient.post(`/candidate/resend-password-reset/`, {
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.email || 
                        error.response?.data?.message ||
                        "Failed to resend password reset";
    return { success: false, error: errorMessage };
  }
};

export const validateToken = async (token) => {
  try {
    const response = await apiClient.post(`/candidate/validate-token/`, { token });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: "Invalid or expired token" };
  }
};

const candidateService = {
  createCandidate,
  getCandidates,
  searchCandidates,
  getCandidatesbyId,
  updateCandidate,
  getNote,
  createNote,
  createCandidateNote,
  getCandidateNote,
  getCandidateSkills,
  createCandidateSkill,
  updateCandidateSkill,
  deleteCandidateSkill,
  addSkillDocument,
  removeSkillDocument,
  addMultipleSkillDocuments,
  getCandidateEmployment,
  createCandidateEmployment,
  updateCandidateEmployment,
  createCandidateWorkingPattern,
  createOrUpdateWorkingPattern,
  getCandidateWorkingPattern,
  getCandidateHolidays,
  createCandidateHoliday,
  updateCandidateHoliday,
  deleteCandidateHoliday,
  createCandidateCredentials,
  getCandidateCredentials,
  updateCandidateCredentials,
  deleteCandidateCredential,
  getUnAllocatedCandidates,
  setPassword,
  resendSetupLink,
  resendPasswordReset,
  validateToken
};

export default candidateService;